import i18n from '../../i18n';
import { getAlertTypeConfig } from '../utils/alertLabels';
import { formatCandidateDisplayValue } from '../utils/formatCandidateField';

const now = Date.now();
const hoursAgo = (h) => new Date(now - h * 60 * 60 * 1000).toISOString();

const MOCK_CANDIDATES_RAW = [
  {
    id: 'demo-1',
    full_name: 'Anna de Vries',
    current_position: 'Frontend Engineer',
    current_company: 'TechCorp NL',
    avatar: null,
    zoho_id: 'z-1001',
    status: 'active-seeker',
    isInvalidLink: false,
    isManualOpenToWork: false,
    hasScraped: true,
    lastCheckDate: '07-09-2026',
    isPrioritized: true,
    phone: '+31612345678',
    isNew: true,
  },
  {
    id: 'demo-2',
    full_name: 'Mark Jansen',
    current_position: 'Product Manager',
    current_company: 'Innovate BV',
    avatar: null,
    zoho_id: '',
    status: 'potential-seeker',
    isInvalidLink: false,
    isManualOpenToWork: false,
    hasScraped: true,
    lastCheckDate: '06-09-2026',
    isPrioritized: false,
    phone: '',
    isNew: false,
  },
  {
    id: 'demo-3',
    full_name: 'Sofia Bakker',
    current_position: 'Data Analyst',
    current_company: 'DataWorks',
    avatar: null,
    zoho_id: 'z-1003',
    status: 'stable',
    isInvalidLink: false,
    isManualOpenToWork: true,
    hasScraped: true,
    lastCheckDate: '05-09-2026',
    isPrioritized: false,
    phone: '+31687654321',
    isNew: false,
  },
  {
    id: 'demo-4',
    full_name: 'Noah Visser',
    current_position: 'DevOps Engineer',
    current_company: 'CloudNine',
    avatar: null,
    zoho_id: '',
    status: 'pending',
    isInvalidLink: false,
    isManualOpenToWork: false,
    hasScraped: false,
    lastCheckDate: null,
    isPrioritized: false,
    phone: '+31611223344',
    isNew: false,
  },
];

export const getDemoCandidates = () => MOCK_CANDIDATES_RAW.map((c) => ({
  id: c.id,
  profileImage: c.avatar,
  profileImageAlt: `${c.full_name} profile`,
  fullName: c.full_name,
  currentRole: formatCandidateDisplayValue(c.current_position),
  jobTitle: formatCandidateDisplayValue(c.current_position),
  companyName: formatCandidateDisplayValue(c.current_company),
  status: c.status,
  isInvalidLink: c.isInvalidLink,
  isManualOpenToWork: c.isManualOpenToWork,
  zohoId: c.zoho_id,
  isFromZoho: Boolean(c.zoho_id),
  hasScraped: c.hasScraped,
  lastCheckDate: c.lastCheckDate,
  isPrioritized: c.isPrioritized,
  phone: c.phone,
  isNew: c.isNew,
}));

const buildActivity = ({ id, candidateId, name, role, alertType, description, createdAt, zoho = false, label }) => {
  const typeConfig = getAlertTypeConfig(alertType);
  return {
    id,
    candidateId,
    candidateName: name,
    avatar: null,
    avatarAlt: `${name} profile`,
    currentRole: formatCandidateDisplayValue(role),
    isFromZoho: zoho,
    description,
    alertType,
    alertTypeLabel: label || typeConfig.label,
    alertTypeClassName: typeConfig.className,
    time: createdAt,
    status: 'new',
    createdAt,
  };
};

export const getDemoActivities = () => [
  buildActivity({
    id: 'a1',
    candidateId: 'demo-1',
    name: 'Anna de Vries',
    role: 'Frontend Engineer',
    alertType: 'open_to_work',
    label: i18n.t('candidates.statusActiveSeeker'),
    description: i18n.t('alerts.fallbackOpenToWork', { name: 'Anna de Vries' }),
    createdAt: '07-09-2026 10:24',
    zoho: true,
  }),
  buildActivity({
    id: 'a2',
    candidateId: 'demo-2',
    name: 'Mark Jansen',
    role: 'Product Manager',
    alertType: 'potential_open_to_work',
    description: 'Updated headline with open-to-work signals.',
    createdAt: '06-09-2026 16:02',
  }),
  buildActivity({
    id: 'a3',
    candidateId: 'demo-3',
    name: 'Sofia Bakker',
    role: 'Data Analyst',
    alertType: 'new_certification',
    description: 'Added a new certification: Google Data Analytics.',
    createdAt: '05-09-2026 09:41',
    zoho: true,
  }),
];

export const getDemoCalls = () => [
  {
    id: 'c1',
    created_at: hoursAgo(5),
    summary: 'Interested in a intro call next week.',
    status: 'Scheduled interview',
    callDuration: 184,
    candidateId: 'demo-1',
    candidate: {
      id: 'demo-1',
      full_name: 'Anna de Vries',
      avatar: null,
      current_position: 'Frontend Engineer',
    },
  },
  {
    id: 'c2',
    created_at: hoursAgo(26),
    summary: 'Open to meet after current project wraps up.',
    status: 'Open to meet',
    callDuration: 211,
    candidateId: 'demo-2',
    candidate: {
      id: 'demo-2',
      full_name: 'Mark Jansen',
      avatar: null,
      current_position: 'Product Manager',
    },
  },
  {
    id: 'c3',
    created_at: hoursAgo(50),
    summary: null,
    status: 'No response',
    callDuration: 42,
    candidateId: 'demo-3',
    candidate: {
      id: 'demo-3',
      full_name: 'Sofia Bakker',
      avatar: null,
      current_position: 'Data Analyst',
    },
  },
];
